<header>
    <h1 class="organisation-name">{{organisationName$ | async}}</h1>
</header>